export const GENERAL_FONT = 'Arial';

export const MHColours = {
  mhBackground: '#FDEAE2',
  mhGreen: '#00968F',
  mhGreenDark: '#005B57',
  mhGreenLight: '#DBF2F1',
  mhDeepTeal: '#0E6C68',
  mhGrayBorder: '#878787',
  mhGrayDark: '#686868',
  mhYellow: '#FFF4DA',
  mhLightBlue: '#C0EFED',
  mhRed: '#DA291C',
  mhMigraineRed: '#EA4E6A',
  mhMigraineBlue: '#4392F1',
  mhMigraineSeeBlue: '#17B5AB',
  mhMigraineYellow: '#FFC90A',
  mhMigraineOrange: '#FF9505',
  mhMigraineGreenLight: '#A5DF00',
  mhMigraineGreenDark: '#17B5AB',
  mhMigraineGreenFluorescent: '#39E17C',
  mhMigrainePurpleLight: '#9BA2FF',
  mhMigrainePurple: '#C368EE',
  mhMigrainePink: '#FF97AB',
};
